export default {
    computed: {
      routeParamArtworkId() {
        return this.$route.params.aid || '';
      },
      routeParamProductId() {
        return this.$route.params.aid.replace("p", "") || '';
      },
      isRouteParamProduct() {
        return this.$route.params.aid.includes("p")
      }
    }
  }